import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { customModalStyles } from '../../helpers/constants';
import DeleteIcon from '../../images/icon-alert.svg';
import * as styles from './style';
import withVariations from '../../containers/GlobalVariations';
import FormLoader from '../../components/FormLoader';
import { getParentSelector } from '../../helpers/modal';

const DeleteVariationModal = ({
  deleteVariation,
  variationPersisted,
  showDeleteVariantModal,
  finishDeleteVariation,
  isLoadingDeleteVariation,
  isDeleteVariationFinished,
  variationDeleteError,
  closeModal,
}) => {
  const confirmDelete = () => {
    closeModal();
    deleteVariation(variationPersisted.id);
  };

  const showFormLoader = () => isLoadingDeleteVariation || isDeleteVariationFinished;

  return (
    <Fragment>
      <FormLoader
        onClose={finishDeleteVariation}
        isSubmiting={isLoadingDeleteVariation}
        showModal={showFormLoader()}
        finishedText="Variação excluída com sucesso!"
        loadingText="Excluindo Variação..."
      />
      <Modal
        ariaHideApp={false}
        className="remove-global-variation-modal"
        isOpen={showDeleteVariantModal}
        style={{
          ...customModalStyles,
          content: {
            ...customModalStyles.content,
            width: '90%',
            maxWidth: '361px',
            height: 'auto',
          },
        }}
        onRequestClose={isDeleteVariationFinished ? closeModal : null}
        parentSelector={getParentSelector}
      >
        <styles.Container>
          <styles.Content>
            <styles.Icon src={DeleteIcon} id="remove-global-variation-modal-remove-icon" />
            {!variationDeleteError ? (
              <Fragment>
                <styles.Title id="remove-global-variation-modal-title">
                  Você tem certeza que deseja excluir esta Variação Global?
                </styles.Title>
                <styles.Text>Esta Variação Global será excluída de</styles.Text>
                <styles.Text>todos os produtos que ela esta atrelada.</styles.Text>
              </Fragment>
            ) : (
              <styles.ErrorContainer>
                <styles.Title id="remove-global-variation-modal-error-title">Erro</styles.Title>
                <styles.Text>Ocorreu um erro ao excluir a Variação.</styles.Text>
                <styles.Text>Por favor tente novamente mais tarde.</styles.Text>
              </styles.ErrorContainer>
            )}
          </styles.Content>
          <styles.Footer center={isDeleteVariationFinished || variationDeleteError}>
            {isDeleteVariationFinished || variationDeleteError ? (
              <styles.CancelButton
                onClick={closeModal}
                id="remove-global-variation-modal-close-button"
              >
                Fechar
              </styles.CancelButton>
            ) : (
              <Fragment>
                <styles.CancelButton
                  onClick={closeModal}
                  id="remove-global-variation-modal-cancel-button"
                >
                  Cancelar
                </styles.CancelButton>
                <styles.DeleteButton
                  onClick={confirmDelete}
                  id="remove-global-variation-modal-submit-button"
                >
                  Excluir
                </styles.DeleteButton>
              </Fragment>
            )}
          </styles.Footer>
        </styles.Container>
      </Modal>
    </Fragment>
  );
};

DeleteVariationModal.propTypes = {
  showDeleteVariantModal: PropTypes.bool,
  isLoadingDeleteVariation: PropTypes.bool,
  isDeleteVariationFinished: PropTypes.bool,
  deleteVariation: PropTypes.func,
  closeModal: PropTypes.func,
  variationPersisted: PropTypes.object,
};

DeleteVariationModal.defaultProps = {
  showDeleteVariantModal: false,
  isLoadingDeleteVariation: false,
  isDeleteVariationFinished: false,
  variationPersisted: {},
};

export default withVariations(DeleteVariationModal);



// WEBPACK FOOTER //
// ./src/components/DeleteVariationModal/index.js